import React, { useEffect, useRef, useState } from 'react'
import { BsChevronDown } from 'react-icons/bs'
import { useTranslation, LANGUAGES } from '../../i18n/LanguageContext'
import { FLAGS } from './Flags'
import './LanguageSelector.scss'

export const LanguageSelector = () => {
    const { lang, setLang, t } = useTranslation()
    const [open, setOpen] = useState(false)
    const ref = useRef(null)

    // Close on outside click or Escape
    useEffect(() => {
        if (!open) return
        const onPointer = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
        const onKey = (e) => { if (e.key === 'Escape') setOpen(false) }
        document.addEventListener('mousedown', onPointer)
        document.addEventListener('touchstart', onPointer)
        document.addEventListener('keydown', onKey)
        return () => {
            document.removeEventListener('mousedown', onPointer)
            document.removeEventListener('touchstart', onPointer)
            document.removeEventListener('keydown', onKey)
        }
    }, [open])

    const CurrentFlag = FLAGS[lang]

    const choose = (code) => {
        setLang(code)
        setOpen(false)
    }

    return (
        <div className="langSelector" ref={ref}>
            <button
                type="button"
                className="langToggle"
                aria-haspopup="listbox"
                aria-expanded={open}
                aria-label={t('nav.language')}
                onClick={() => setOpen(!open)}
            >
                <CurrentFlag />
                <span className="langCode">{lang.toUpperCase()}</span>
                <BsChevronDown className={`langChevron ${open ? 'open' : ''}`} />
            </button>

            {open && (
                <ul className="langMenu" role="listbox" aria-label={t('nav.language')}>
                    {LANGUAGES.map(({ code, name }) => {
                        const Flag = FLAGS[code]
                        return (
                            <li key={code} role="option" aria-selected={code === lang}>
                                <button type="button" lang={code} className={code === lang ? 'active' : ''} onClick={() => choose(code)}>
                                    <Flag />
                                    <span>{name}</span>
                                </button>
                            </li>
                        )
                    })}
                </ul>
            )}
        </div>
    )
}
